import type { Dayjs } from "dayjs";

import { formatDuration } from "./formatDuration";

interface IGetAlertsDefaultDurationParams {
    minDate: Dayjs;
    maxDate: Dayjs;
}

export const getAlertsDefaultDuration = ({ minDate, maxDate }: IGetAlertsDefaultDurationParams) => {
    const start = maxDate.subtract(6, "day");
    const from = start.isBefore(minDate) ? minDate : start;

    return formatDuration({ from, to: maxDate });
};
